import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { SmartFileInput } from 'app/components/shared/FormComponents/SmartFileInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { Button } from 'app/components/ui/Button'
import { Form } from 'app/components/ui/Form'
import { Text } from 'app/components/ui/Text'
import { useUploadSignedOutcomeDocument } from 'app/queries/sponsorRequests'
import { theme } from 'app/styles/themeEstra'
import { pdfInputTypes } from 'app/utils/fileUtils'
import React from 'react'
import styled from 'styled-components'

import {
  adaptFormDataToAPI,
  SponsorRequestContractSignFormData,
  sponsorRequestContractSignFormDefaultValues,
  sponsorRequestContractSignFormValidationSchema,
} from './form'

type Props = {
  sponsorRequestId: number
  sponsorRequestOutcomeDocument: string
  onCancel: () => void
  onSuccess?: () => void
}

export const SponsorRequestContractSignForm = ({
  sponsorRequestId,
  sponsorRequestOutcomeDocument,
  onSuccess,
  onCancel,
}: Props): JSX.Element => {
  const {
    mutate: uploadFile,
    isLoading,
    isError,
    error,
  } = useUploadSignedOutcomeDocument()

  const onSubmit = (data: SponsorRequestContractSignFormData) =>
    uploadFile(
      {
        sponsor_request_id: sponsorRequestId.toString(),
        formData: adaptFormDataToAPI(data),
      },
      {
        onSuccess: onSuccess,
      }
    )

  return (
    <Form<SponsorRequestContractSignFormData>
      defaultValues={sponsorRequestContractSignFormDefaultValues}
      validationSchema={sponsorRequestContractSignFormValidationSchema}
      onSubmit={onSubmit}
    >
      <DownloadDocumentWrapper>
        <Text variant='s18' color={theme.color.primari.grigioEstra} mb={2}>
          Scarica il documento del contratto cliccando il bottone qua sotto, poi
          firmalo e ricaricalo.
        </Text>
        <Button
          href={sponsorRequestOutcomeDocument || '#'}
          target='_blank'
          rel='noopener noreferrer'
          variant='cyan'
        >
          Scarica il contratto
        </Button>
      </DownloadDocumentWrapper>
      <FormGroup>
        <SmartFileInput
          name='outcome_document_file'
          accept={pdfInputTypes.join(', ')}
          description='Formato immagine o PDF, dimensione massima 10 MB'
          label='Carica il documento firmato'
          labelRequired
        ></SmartFileInput>
      </FormGroup>
      <ButtonApiErrorWrapper isError={isError} error={error} alignCenter>
        <ButtonsWrapper>
          <Button onClick={onCancel} variant='grey'>
            Annulla
          </Button>
          <Button type='submit' disabled={isLoading}>
            {isLoading ? 'Caricamento...' : 'Conferma'}
          </Button>
        </ButtonsWrapper>
      </ButtonApiErrorWrapper>
    </Form>
  )
}

const DownloadDocumentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  width: 100%;

  margint-top: 2rem;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    justify-content: flex-end;
  }
`
